import { DotPulse as n } from "@uiball/loaders";
import { useThemeUI as i, get as m } from "theme-ui";
import { jsx as c } from "theme-ui/jsx-runtime";
const a = (r) => {
  const {
    variant: e = "dot-pulse",
    color: o = "primary",
    size: t,
    speed: s
  } = r, {
    theme: p
  } = i(), l = m(p, `colors.${o}`);
  return e === "dot-pulse" ? /* @__PURE__ */ c(n, {
    size: t ?? 40,
    speed: s ?? 1.3,
    color: l ?? o
  }) : null;
};
export {
  a as Spinner
};
